.language-switcher {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.language-icon {
  color: inherit;
}

.language-select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.language-select {
  appearance: none;
  background: transparent;
  border: none;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  padding-right: 1.2rem;
  outline: none;
}

.language-chevron {
  position: absolute;
  right: 0;
  pointer-events: none;
  color: inherit;
}



.language-select option {
  color: var(--color-text-primary);
  background: var(--color-bg-surface);
}
